/**
 * Utility functions for QuickiBible user avatars.
 */

/**
 * Appends a cache-buster query parameter (?v=timestamp) to avatar URLs ONLY for rendering.
 * Does NOT alter or store the query string in the database or profile state.
 */
export function getAvatarUrlWithCacheBuster(
  url?: string | null,
  version?: number | string
): string {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';

  // Data URIs don't need cache busters
  if (trimmed.startsWith('data:')) return trimmed;

  // Clean URL by stripping existing query parameters
  const cleanUrl = trimmed.split('?')[0];
  if (!version) return cleanUrl;
  return `${cleanUrl}?v=${version}`;
}

/**
 * Strips cache-buster or query strings from an avatar URL so that only
 * clean, canonical URLs are saved to database/store.
 */
export function getCleanAvatarUrl(url?: string | null): string {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return trimmed;
  return trimmed.split('?')[0];
}
